import {
  type Coordinates,
  type PlaceBoundingBox,
} from '@/features/place/types/place-types';

export default function calculateCenterFromBbox(bbox: PlaceBoundingBox): Coordinates {
  return {
    latitude: (bbox.latitudeSouthWest + bbox.latitudeNorthEast) / 2,
    longitude: (bbox.longitudeSouthWest + bbox.longitudeNorthEast) / 2,
  };
}
